var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.002 10C5.277 10 2.6845 8.5865 0.297 5.7985C-0.099 5.336 -0.099 4.6645 0.297 4.202C2.6845 1.414 5.277 0 8.002 0C10.727 0 13.3195 1.414 15.707 4.202C16.103 4.6645 16.103 5.336 15.7065 5.7985C13.3195 8.5865 10.727 10 8.002 10ZM1.0565 4.8525C0.984 4.9365 0.984 5.0635 1.0565 5.148C3.2455 7.704 5.5825 9 8.002 9C10.422 9 12.7585 7.704 14.9475 5.1475C15.02 5.0635 15.02 4.9365 14.948 4.8525C12.7585 2.296 10.422 1 8.002 1C5.5825 1 3.2455 2.296 1.0565 4.8525ZM8.002 8C6.3475 8 5.002 6.6545 5.002 5C5.002 3.3455 6.3475 2 8.002 2C9.6565 2 11.002 3.3455 11.002 5C11.002 6.6545 9.6565 8 8.002 8ZM8.002 3C6.899 3 6.002 3.897 6.002 5C6.002 6.103 6.899 7 8.002 7C9.105 7 10.002 6.103 10.002 5C10.002 3.897 9.105 3 8.002 3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5230_28377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.002 10C5.277 10 2.6845 8.5865 0.297 5.7985C-0.099 5.336 -0.099 4.6645 0.297 4.202C2.6845 1.414 5.277 0 8.002 0C10.727 0 13.3195 1.414 15.707 4.202C16.103 4.6645 16.103 5.336 15.7065 5.7985C13.3195 8.5865 10.727 10 8.002 10ZM1.0565 4.8525C0.984 4.9365 0.984 5.0635 1.0565 5.148C3.2455 7.704 5.5825 9 8.002 9C10.422 9 12.7585 7.704 14.9475 5.1475C15.02 5.0635 15.02 4.9365 14.948 4.8525C12.7585 2.296 10.422 1 8.002 1C5.5825 1 3.2455 2.296 1.0565 4.8525ZM8.002 8C6.3475 8 5.002 6.6545 5.002 5C5.002 3.3455 6.3475 2 8.002 2C9.6565 2 11.002 3.3455 11.002 5C11.002 6.6545 9.6565 8 8.002 8ZM8.002 3C6.899 3 6.002 3.897 6.002 5C6.002 6.103 6.899 7 8.002 7C9.105 7 10.002 6.103 10.002 5C10.002 3.897 9.105 3 8.002 3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5230_28377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.498047,
    y: -3.1875,
    width: 17,
    height: 17,
    fill: "#8E9AB3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEye);
export default __webpack_public_path__ + "static/media/grey-eye.db3809b04884d5c2d8a398356c993e2c.svg";
export { ForwardRef as ReactComponent };